import api from "../services/api";

export const fetchLoyaltyConfig = async () => {
  try {
    const response = await api.get("/loyalty-management/config");

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    return { success: false, error: error.message || "Failed to fetch config" };
  }
};


export const createLoyaltyConfig = async (payload) => {
  try {
    const response = await api.post("/loyalty-management/config", payload);

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    return { success: false, error: error.message || "Failed to create config" };
  }
};


export const updateLoyaltyConfig = async (payload) => {
  try {
    const response = await api.put("/loyalty-management/config", payload);

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    return { success: false, error: error.message || "Failed to update config" };
  }
};


export const deleteLoyaltyConfig = async () => {
  try {
    const response = await api.delete("/loyalty-management/config");

    if (response.status === 200) {
      return { success: true, message: "Config deleted successfully" };
    } else {
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    return { success: false, error: error.message || "Failed to delete config" };
  }
};